import { useContext } from "react";
import { Asset } from "../../../data/Asset";
import { VillageDto } from "../../../dtos/VillageDto";
import { CardSwapStatusDto } from "../dtos/CardSwapStatusDto";
import { DataRow } from "./DataRow";
import { useCardSwapHttp } from "../hooks/useCardSwapHttp";
import { useVillagesHttp } from "../../../hooks/useVillagesHttp";
import VspPortalContext from "../../../store/VspPortalContext";
import { CardSwapUpdateDto } from "../dtos/CardSwapUpdateDto";
import { CardSwapSearchDto } from "../dtos/CardSwapSearchDto";
import { GridSortItem } from "@mui/x-data-grid";


export const useCardSwapSearchResults = ( cardSwapStatuses : string[ ], villageCodes : string[ ] ) => {

    const { getCardSwapStatuses, searchCardSwap, updateCardSwap } = useCardSwapHttp( );
    const { getVillages } = useVillagesHttp( );

    const { state } = useContext( VspPortalContext );
    

    const exportCardSwapSearchResults = ( rows : DataRow[ ] ) => {

        const formattedRows = [ ];

        const columnNames = [
            'First Name',
            'Last Name',
            'Email',
            'Employee / ERMS ID',
            'New Card',
            'Card Collection Village',
            'Status',
        ];

        formattedRows.push( columnNames );

        rows.forEach( row => 
            formattedRows.push( [
                row["firstName"],
                row["surname"],
                row["email"],
                row["employeeNumber"],
                row["newCardNumber"],
                row["village"],
                row["cardSwapStatus"]
            ] ) 
        );

        let csvContent = "data:text/csv;charset=utf-8," + formattedRows.map( e => e.join( "," ) ).join( "\n" );
        const encodedUri = encodeURI( csvContent );
        const link = document.createElement( "a" );
        link.setAttribute( "href", encodedUri );
        link.setAttribute( "download", "data.csv" );
        document.body.appendChild( link );
        link.click( );

    };
    

    const fetchData = async( pageNumber : number, pageSize : number, sorting: GridSortItem  ) => {

        const cardSwapSearch : CardSwapSearchDto | null = await searchCardSwap( cardSwapStatuses, pageNumber, pageSize, sorting, villageCodes );
        const rows: DataRow[ ] = [];

        let villages : VillageDto[ ] = [];

        villages = await getVillages( Asset.Waio ) as VillageDto[ ];
        
        let cardSwapStatusDtos : CardSwapStatusDto[ ] = [];

        if( state.cardSwapStatuses.length === 0) {

            cardSwapStatusDtos = await getCardSwapStatuses( ) as CardSwapStatusDto[ ];

        } else {

            cardSwapStatusDtos = [...state.cardSwapStatuses ];

        }
        
        if( cardSwapSearch ) {

            for( const cardSwapSearchResult of cardSwapSearch.items ){

                rows.push({

                    id : cardSwapSearchResult.id, 
                    cardSwapStatus: cardSwapStatusDtos.find( c => c.code === cardSwapSearchResult.refCardSwapStatusCode )?.description as string,
                    firstName: cardSwapSearchResult.firstName,
                    email: cardSwapSearchResult.email,
                    employeeNumber: cardSwapSearchResult.employeeNumber,
                    newCardNumber : cardSwapSearchResult.newCardNumber,
                    surname: cardSwapSearchResult.surname,
                    village: villages.find( v => v.villageCode === cardSwapSearchResult.villageCode)?.villageName as string

                });

            }
        } 

        return { cardSwapSearchResults: cardSwapSearch, rows };
    }; 


    const sendNotification = async( cardSwapUpdateDto : CardSwapUpdateDto ) => updateCardSwap( cardSwapUpdateDto );

    return {
        
        exportCardSwapSearchResults
        , fetchData
        , sendNotification

    };

};